import MixpanelTracker from '../../mixpanelTracker';
import { REGISTRATION, EVENT_DETAILS, WEBINAR_LEVEL_RSVP_INVITE_SETTING } from '../../mixpanelConstants';

const mixpanelTracker = new MixpanelTracker();

export function trackRegistrationUpdated(subType, action) {
  const properties = {
    Type: REGISTRATION,
    SubType: subType,
    Action: action
  };
  mixpanelTracker.setEventName(EVENT_DETAILS);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackRegistrationQuestion(subType, questionType, action) {
  const properties = {
    Type: REGISTRATION,
    SubType: subType,
    QuestionType: questionType,
    Action: action
  };
  mixpanelTracker.setEventName(EVENT_DETAILS);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function trackConfirmationEmailInviteChange(sendConfirmationInvite, sendConfirmationAcknowledgement, webinarKey) {
  const properties = {
    emailInvitation: sendConfirmationInvite ? 'on' : 'off',
    rsvpResponse: sendConfirmationAcknowledgement ? 'on' : 'off',
    webinarKey
  };
  mixpanelTracker.setEventName(WEBINAR_LEVEL_RSVP_INVITE_SETTING);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

